const stripeMenu = {
    sites: [
        {
            label: "CRF",
            url: "http://www.crf.org",
        },
        {
            label: "SKIRBALL",
            url: "https://www.skirballresearch.org/",
        },
        {
            label: "CTC",
            url: "https://www.crf.org/clinical-trials-center",
        },
        {
            label: "CED",
            url: "https://www.crf.org/center-for-education",
        },
        {
            label: "TCTMD",
            url: "https://www.crf.org/center-for-education/tctmd",
        },
        {
            label: "SHJ",
            url: "https://www.crf.org/crf/shj",
        },
    ],

    meetings: [
        {
            label: "TCT",
            url: "https://tct.crfconferences.com/",
        },
        {
            label: "NY VALVES",
            url: "https://www.nyvalvesconference.com/",
        },
        {
            label: "COMPLEX CORONARY SUMMIT",
            url: "https://www.complexcoronarysummit.com/",
        },
        {
            label: "THT",
            url: "https://tht.crfconferences.com/",
        },
        {
            label: "CTO",
            url: "https://cto.crfconferences.com/",
        },
        {
            label: "FELLOWS",
            url: "https://fellows.crfconferences.com/",
        },
        {
            label: "COMPLICATIONS COURSE",
            url: "https://complications.crfconferences.com/",
        },

        {
            label: "TCT PLUS LATAM",
            url: "https://tctpluslatam.com/",
        },
        {
            label: "TCT PLUS MIDDLE EAST",
            url: "https://tctmiddleeast.crfconferences.com/",
        },
        {
            label: "TCT PLUS AFRICA",
            url: "https://tctafrica.crfconferences.com",
        },
    ],
}

export default stripeMenu
